import React from 'react'
import './Topnav.css'
import { FaPhone } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

function Topnav() {
  return (
    <div className='topnav'>
        <Link to='/contact-us' className='text-decoration-none' style={{display: 'flex', alignItems: 'center'}}>
          <FaPhone size={20} color='white'/>
          <h5>Contact Us</h5>
        </Link>
    </div>
  )
}

export default Topnav